// extracted by mini-css-extract-plugin
export default {"text":"truncatedText_text__aLm-C","tooltip":"truncatedText_tooltip__g9FZO"};